export default {
  leagues: {
    title: "Selecionar liga",
    empty: {
      favoriteLeagues: "Marque suas ligas favoritas para deixá-las no topo e acessar mais rápido",
    },
    actions: {
      starFavoriteLeagues: "Marcar ligas favoritas",
    },
    status: {
      live: "Ativo",
      offseason: "Offseason",
    },
    sections: {
      myLeagues: "Minhas ligas",
      sports: {
        baseball: "Beisebol",
        basketball: "Basquete",
        football: "Futebol americano",
        "australian-football": "Futebol australiano",
        rugby: "Rúgbi",
        hockey: "Hóquei",
        soccer: "Futebol",
      },
    },
  },
};
